// extracted by mini-css-extract-plugin
module.exports = {"taux":"Rate_taux__1_r39"};